import { createContext, useContext } from 'react';
import type { MentionAttrs } from '../mention-extension';

type ChatInputMentionContextValue = {
  mentionEntity: (attrs: MentionAttrs) => void;
};

export const ChatInputMentionContext = createContext<ChatInputMentionContextValue | null>(null);

export const useChatInputMention = (): ChatInputMentionContextValue | null => useContext(ChatInputMentionContext);
